export const baseWhisleoutUrl = `https://7news.whistleout.com.au/Widgets/`

export const isWhistleOut = (link: string) => {
    return link.indexOf('whistleout.com.au/Widgets') > 0
}

// Generate the appropriate whislteout iframe link
export const generateFrameSrc = (link: string, isAmp?: boolean) => {
    const id = isAmp ? 'Amp' : 'IFrame'
    // Replace the query ? with /id? or return link/id
    const srcUrl = link.indexOf('?') >= 0 ? link.replace('?', `/${id}?`) : `${link}/${id}`
    return srcUrl.replace('https://www.whistleout.com.au', 'https://7news.whistleout.com.au')
}
